<template>
  <div class="signup app-content" :class="{'payment-area': showComplete,  'bg-gray': showComplete}">
    <div class="container pt-2 pb-5">
      <div class="row mt-3  mb-5">
        <div id="f_signup" class="col-12 col-md-8 mx-auto px-0" v-if="!showComplete">
            <h2 slot="title"></h2>
            <div class="mt-2" v-if="mode === 'language'">
              <language  @next="nextStep"></language>
            </div>
             <div v-else-if="mode ==='occupation'" class=" mb-5">
              <occupation  @next="nextStep"></occupation>
            </div>
             <div class="mt-2 mb-5" v-else-if=" mode === 'profileInfo'">
              <create-profile  @next="nextStep"></create-profile>
            </div>

            <div class="mt-2 mb-5" v-else-if=" mode === 'confirm'">
              <setting-confirm  @next="nextStep" :registData="registData"></setting-confirm>
            </div>
        </div>

        <div class="col-12 col-md-6 mx-auto text-center done signup" v-if="mode ==='complite'">
          <b-card class="bg-white px-5 pt-4 pb-4 col-md-12">
            <h4><b>{{$t("message.done_member_regist_2")}}</b></h4>
            <p class="mt-5 mb-3"> {{$t("message.done_member_regist_description_2")}}</p>
            <router-link :to="'/mypage'">
              <b-button  class="next mt-4 py-2 px-4"  > {{$t("message.mypage")}} </b-button>
            </router-link>

            <p class="mt-5 mb-3"> {{$t("message.pleace_add_messenger")}}</p>
            <a href="https://www.facebook.com/messages/t/103049354838198">
              <b-button  class="messenger mt-4 py-2 px-4"> {{$t("message.add_messenger_bot")}} </b-button>
            </a>
            <!--
            <h5 class="card-title article-title font-blue pt-5 text-left">{{$t("message.article6_sub1")}}</h5>
            <p class="card-text">{{$t("message.article6_sub1_dec1")}}</p>
            <div class="row">
              <div class="col-12 text-left">
                <h1 class="money">500</h1>
                <h5 class="money-unit">{{$t("message.yen_per_month")}}</h5>
              </div>
            </div>
            -->
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import CreateProfile from "@/components/User/Setting/CreateProfile"
import Language from "@/components/User/Setting/Language"
import Occupation from "@/components/User/Setting/Occupation"
import SettingConfirm from "@/components/User/Setting/SettingConfirm"
import { mapState } from 'vuex';

export default {
  components: {
    CreateProfile,
    Language,
    Occupation,
    SettingConfirm
  },
  data () {
    return {
      mode: 'language',
      idToken: localStorage.idToken,
      showComplete: false,
      registData: {}
    }
  },
  methods: {
    nextStep(data){
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
      if(data.mode != "confirm"){
        this.mode = data.mode
      }
      else{
        this.mode = data.mode
        console.log('registData',data.data)
        this.registData = data.data

      }
    },
    moveToTop: function() {
      this.$scrollTo('#f_signup')
    },
    onComplete: function(){
      this.showComplete = true
      this.$scrollTo('#f_signup')
      //setTimeout(() => {
      //  this.$router.push('./mypage')
      //},4000)
    },
    setLanguage(){
      return new Promise((resolve, reject) => {
        const result = this.$refs.language.regist_lang()
        result.then(value =>{
          if(value){
              resolve(value);
            }else{
              reject()
            }
        })
      })
    },
    setOccupation(){
      return new Promise((resolve, reject) => {
        var result = this.$refs.occupation.regist_occupation()
        result.then(value =>{
          if(value){
            resolve(value);
          }else{
            reject()
          }
        })
      })
    }
  },
  async mounted() {
    //if (this.user.status == "no_deposite_member") {
    //  //this.$router.push('./payment')
    //  // this.$router.push('./mypage')
    //} else if(this.user.status == "member") {
    //  // this.$router.push('./mypage')
    //}
    this.$store.commit('setLoading', false)
  },
  computed: {
    ...mapState({
        user: state => state.user.user
    })
  },

}
</script>

<style scoped lang="scss">

p.error {
    border-color: red;
    background: mistyrose;
    margin-bottom: 0px;
}
.dirty {
    border-color: #F5F5F8;
    background: #F5F5F8;
    width: 100%;
}
input::placeholder{
  font-size: 16px;
  line-height: 24px;
  color: rgba(1, 1, 20, 0.26);
}

.next{
  background: #F29147;
  color: #FFFFFF;
  border-color: #F29147;
}
.done{
  margin-top: 60px;
  height: 430px;
}
.bg-white {
  background: #fff;
}
.signup {
}
.article-title {
  font-style: normal;
  font-weight: bold;
  font-size: 25px;
  line-height: 44px;
}
.money{
  font-weight: bold;
  font-size: 60px;
  line-height: 89px;
  display: inline
}
.money-unit{
  font-weight: bold;
  font-size: 30px;
  line-height: 44px;
  display: inline
}
.card-text {
  text-align: left;
}
.payment-area {
  min-height: 120vh;
}

.messenger{
  background-color: #3374e0;
  border-color: #3374e0;
  color: white;
}

</style>
